// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DDd-O","newExpiryDate":"styles_newExpiryDate__1kWZQ","footer":"styles_footer__3PGfM"};